import React from 'react'
import { Col, Row, Stack } from 'react-bootstrap'

export const PhoneHowItWorks: React.FC = () => {
  return (
    <>
      <Row className='py-2'>
        <Col>
          <Stack direction='horizontal' gap={3}>
            <h6>1</h6>
            Validate your phone number
          </Stack>
        </Col>
      </Row>
      <Row className='py-2'>
        <Col>
          <Stack direction='horizontal' gap={3}>
            <h6>2</h6>
            Save the contact info of your Zocks AI Assistant to your contacts on your phone.
          </Stack>
        </Col>
      </Row>
      <Row className='py-2'>
        <Col>
          <Stack direction='horizontal' gap={3}>
            <h6>3</h6>
            After starting a phone call, use the 'conference call' option to allow your Zocks Assistant to join as an additional participant.
          </Stack>
        </Col>
      </Row>
      <Row className='py-2'>
        <Col>
          <Stack direction='horizontal' gap={3}>
            <h6>4</h6>
            Once your call is over, take a look at your Meeting Summary to gain important insights.
          </Stack>
        </Col>
      </Row>
      <Row className='pt-5'>
        <Col className='px-0'>
          <div className='paragraph-medium'>
            If you would like to learn more, you can read our full{' '}
            <a
              target='_blank'
              href='https://help.zocks.io/en/articles/9969795-how-to-connect-zocks-to-your-phone-calls'
              rel='noreferrer'
              className='button-link-medium zocks-text-gray-900'
            >
              Help&nbsp;article.
            </a>
          </div>
        </Col>
      </Row>
    </>
  )
}
